var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 35,
    viewBox: "0 0 57 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3327 15.3279H1.87354C0.838879 15.3279 0 16.2095 0 17.2968C0 18.3841 0.838879 19.2657 1.87354 19.2657H54.3327C55.3674 19.2657 56.2063 18.3841 56.2063 17.2968C56.2063 16.2095 55.3674 15.3279 54.3327 15.3279Z",
    fill: "#EBECEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamb);
export default __webpack_public_path__ + "static/media/hamb.44dd2d142b08fe1d69717db1a656976b.svg";
export { ForwardRef as ReactComponent };